// Note: When this package was moved in the athena-ts monorepo, it started using
// the common tsconfig, which is more strict than its original tsconfig. In
// particular, it enables the `noUncheckedIndexedAccess` compiler option, which
// marks indexed accesses like `moduleData[moduleId]` as possibly undefined,
// causing then compilation errors. This is desirable, as indeed expressions
// like those can be undefined. For now, since we're just migrating the library
// to the monorepo, and not refactoring it, instead of actually fixing the
// errors by checking that the values are not undefined we added non-null
// assertions.
//
// TODO: Remove all non-null assertions (the ! operator).
export const preprocessData = (params, moduleId) => {
    const preprocessedData = {};
    const moduleData = params.graph.graph;
    const objectives = moduleData[moduleId].subgroups[0];
    // Preprocess module info
    const initSSB = moduleData[moduleId].init_ssb[0];
    const initiallyOpenedObjectives = [];
    for (let idx = 0; idx < initSSB.length; idx++) {
        initiallyOpenedObjectives.push(objectives[initSSB[idx]]);
    }
    preprocessedData[moduleId] = {
        requirements: [],
        subgroups: initiallyOpenedObjectives,
    };
    const requirements = moduleData[moduleId].requirements?.[0] ?? {};
    for (const obj of objectives) {
        preprocessedData[obj] = {
            subgroups: moduleData[obj].subgroups[0],
            requirements: [],
        };
        // Preprocess objective info
        if (requirements[obj]) {
            const objRequirements = requirements[obj];
            for (const [requiredObjectiveId, { lvl, sr }] of Object.entries(objRequirements)) {
                if (!moduleData[requiredObjectiveId]) {
                    console.error(`Objective ${requiredObjectiveId} not found in module data`);
                    continue;
                }
                for (let idx = 0; idx < lvl.length; idx++) {
                    const requiredLevel = lvl[idx];
                    preprocessedData[obj].requirements.push([
                        moduleData[requiredObjectiveId].subgroups[0][requiredLevel],
                        sr[idx],
                    ]);
                }
            }
        }
        // Preprocess activity info
        if (moduleData[obj].requirements) {
            const actRequirements = moduleData[obj].requirements[0];
            const actRequirementsKeys = Object.keys(actRequirements);
            for (const act of actRequirementsKeys) {
                preprocessedData[act] = { subgroups: [], requirements: [] };
                const thisActReq = actRequirements[act];
                for (const objRequired of Object.keys(thisActReq)) {
                    for (let index = 0; index < thisActReq[objRequired].lvl.length; index++) {
                        const requiredLevel = thisActReq[objRequired].lvl[index];
                        preprocessedData[act].requirements.push([
                            moduleData[objRequired].subgroups[0][requiredLevel],
                            thisActReq[objRequired].sr[index],
                        ]);
                    }
                }
            }
        }
        // to handle default prerequisite when nothing is defined in module config
        for (let i = 1; i < preprocessedData[obj].subgroups.length; i++) {
            if (!preprocessedData[preprocessedData[obj].subgroups[i]]) {
                preprocessedData[preprocessedData[obj].subgroups[i]] = {
                    subgroups: [],
                    requirements: [],
                };
                preprocessedData[preprocessedData[obj].subgroups[i]].requirements.push([preprocessedData[obj].subgroups[i - 1], 0.75]);
            }
        }
    }
    return preprocessedData;
};
export const makeGraphFromData = (params, idModule) => {
    const moduleData = params["graph"]["graph"];
    const preprocessedData = preprocessData(params, idModule);
    const graph = {};
    for (const node of Object.keys(preprocessedData)) {
        if (node === idModule) {
            graph[node] = {
                parents: [],
                children: preprocessedData[idModule]["subgroups"],
                status: -1,
            };
        }
        else {
            const subgroups = preprocessedData[node]["subgroups"];
            if (subgroups.length !== 0) {
                const initActIndices = moduleData[node]["init_ssb"][0];
                //const maxIdx = Math.max(initActIndices)
                const initAct = [];
                for (let ii = 0; ii < initActIndices.length; ii++) {
                    initAct.push(subgroups[initActIndices[ii]]);
                    //graph[moduleData[node]["subgroups"][0][initActIndices[ii]]] = {"children":[subgroups[maxIdx+1]],"parents":[node],"status":-1}
                    graph[subgroups[initActIndices[ii]]] = {
                        children: [],
                        parents: [node],
                        status: -1,
                    };
                }
                graph[node] = { children: initAct, parents: [], status: -1 };
                for (let j = 0; j < subgroups.length; j++) {
                    if (!graph[subgroups[j]]) {
                        graph[subgroups[j]] = { children: [], parents: [], status: -1 };
                    }
                }
            }
        }
    }
    for (const node of Object.keys(preprocessedData)) {
        if (node !== idModule) {
            const subgroups = preprocessedData[node]["subgroups"];
            const requirements = preprocessedData[node]["requirements"];
            for (let j = 0; j < subgroups.length; j++) {
                if (!graph[subgroups[j]]) {
                    if (preprocessedData[subgroups[j]]) {
                        graph[subgroups[j]].unlockSuccessRate = [];
                        for (const req of preprocessedData[subgroups[j]].requirements) {
                            if (!graph[subgroups[j]].parents.includes(req[0]))
                                graph[subgroups[j]].parents.push(req[0]);
                            graph[subgroups[j]].unlockSuccessRate.push(req[1]);
                            if (!graph[req[0]].children.includes(subgroups[j]))
                                graph[req[0]].children.push(subgroups[j]);
                        }
                    }
                    else {
                        for (let k = 0; k < j; k++) {
                            if (graph[subgroups[k]].children.length === 0) {
                                graph[subgroups[k]].children.push(subgroups[j]);
                                graph[subgroups[j]].parents.push(subgroups[k]);
                            }
                        }
                    }
                }
            }
            //graph[subgroups[maxIdx+1]] = {"children":[subgroups[maxIdx+2]],"parents":initAct,"status":-1}
            //for (let i=maxIdx+2;i<subgroups.length-1;i++){
            //graph[subgroups[i]] = {"children": [subgroups[i+1]],"parents": [subgroups[i-1]],"status":-1}
            //}
            //graph[subgroups[subgroups.length-1]] = {"children":[],"parents":[subgroups[subgroups.length-2]],"status":-1}
            for (let j = 0; j < requirements.length; j++) {
                graph[requirements[j][0]]["children"].push(node);
                graph[node]["parents"].push(requirements[j][0]);
                if (!Object.keys(graph[node]).includes("unlockSuccessRate")) {
                    graph[node]["unlockSuccessRate"] = [];
                }
                graph[node]["unlockSuccessRate"].push(requirements[j][1]);
            }
        }
    }
    for (const initObj of preprocessedData[idModule]["subgroups"]) {
        graph[initObj]["parents"].push(idModule);
    }
    return graph;
};
export const BFS = (graph, node) => {
    const queue = [node];
    const visited = [node];
    while (queue.length > 0) {
        const s = queue.pop();
        if (s) {
            for (const neighbour of graph[s]["children"]) {
                if (!visited.includes(neighbour)) {
                    visited.push(neighbour);
                    queue.push(neighbour);
                }
            }
        }
    }
    return visited;
};
export const getDescendants = (graph, idNode) => {
    return BFS(graph, idNode);
};
export const getAncestors = (graph, idNode) => {
    const computedAncestors = new Map();
    return Array.from(getAncestorsTailRecursive(graph, idNode, computedAncestors, new Set()));
};
function getAncestorsTailRecursive(graph, idNode, computedAncestors, ancestors = new Set()) {
    // Base case: if the node has no parents, return a set with the node itself
    if (graph[idNode]["parents"].length === 0) {
        const singleSet = new Set([idNode]);
        computedAncestors.set(idNode, singleSet);
        return singleSet;
    }
    // Loop in the graph. Returns and print an error
    if (ancestors.has(idNode)) {
        console.error("There is a loop in the graph containing the following learning_set ids", ancestors, idNode);
        computedAncestors.set(idNode, ancestors);
        return ancestors;
    }
    ancestors.add(idNode);
    for (const parent of graph[idNode]["parents"]) {
        if (!computedAncestors.has(parent)) {
            getAncestorsTailRecursive(graph, parent, computedAncestors, ancestors);
        }
        else {
            // If already computed, merge the ancestor set from the computed results
            computedAncestors.get(parent).forEach((ancestor) => {
                ancestors.add(ancestor);
            });
        }
    }
    // Cache the result
    computedAncestors.set(idNode, ancestors);
    return ancestors;
}
const firstOccurrenceUnion = (walks) => {
    const seen = new Set();
    const union = [];
    for (const walk of walks) {
        for (const id of walk) {
            if (!seen.has(id)) {
                seen.add(id);
                union.push(id);
            }
        }
    }
    return union;
};
export const getLockClosure = (graph, ids) => firstOccurrenceUnion(ids.map((id) => getDescendants(graph, id)));
export const getUnlockClosure = (graph, ids) => firstOccurrenceUnion(ids.map((id) => getAncestors(graph, id)));
export const actualiseLockedElementsWithDescendants = (graph, lockedElements) => {
    const knownIds = lockedElements.filter((id) => graph[id] !== undefined);
    actualiseLockedElements(graph, getLockClosure(graph, knownIds));
};
export const actualiseLockedElements = (graph, lockedElements) => {
    for (const ID of Object.keys(graph)) {
        if (lockedElements.includes(ID)) {
            graph[ID]["status"] = 3;
        }
    }
};
export const actualiseUnlockedElements = (graph, unlockedElements) => {
    for (const ID of Object.keys(graph)) {
        if (unlockedElements.includes(ID)) {
            graph[ID]["status"] = -1;
        }
    }
};
export const getAllStatuses = (graph) => {
    const statusDict = {};
    for (const node of Object.keys(graph)) {
        statusDict[node] = graph[node]["status"];
    }
    return statusDict;
};
export const actualiseStatuses = (data, graph, ModuleDiag, idModule) => {
    const moduleData = data["config"]["ai"]["moduleConfig"][idModule];
    for (const ID of Object.keys(ModuleDiag["param_state"])) {
        if (ID !== idModule) {
            const indexObj = moduleData[idModule]["subgroups"][0].indexOf(ID);
            graph[ID]["status"] = ModuleDiag["param_state"][idModule][0][indexObj];
            for (let i = 0; i < ModuleDiag["param_state"][ID][0].length; i++) {
                graph[moduleData[ID]["subgroups"][0][i]]["status"] =
                    ModuleDiag["param_state"][ID][0][i];
            }
        }
    }
};
//# sourceMappingURL=graphlib.js.map